<div class="d-flex flex-column align-items-center justify-content-center full-width full-height">
    <div class="mt-3 mb-5">This service is available to professionals with a KForce Excellence or KForce Pro+ licence</div>
    <h1 class="title mt-3 mb-5">KForce <span>Excellence</span></h1>
    <div class="subtitle">The Professional way to <span class="standout-word">Measure</span> and <span class="standout-word">Build</span> Progress for your
        clients
    </div>
    <div class="subtitle bottom-line">Learn more and get your <span class="standout-word">KForce Excellence</span> licence now, from <a
        href="https://k-invent.com/produit/kforce-app-pro-plus/">k-invent.com</a></div>
</div>
